// extracted by css-extract-rspack-plugin
export default {"MainContent":"ArtifactRegistryShow-module__MainContent__hOP3xE4","Sidebar":"ArtifactRegistryShow-module__Sidebar__oYyt_qk"};